import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../../contexts/ThemeContext';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sm};
`;

const ToggleButton = styled(motion.button)`
  background: ${props => props.theme.colors.surfaceVariant};
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius.full};
  width: 52px;
  height: 28px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: ${props => props.theme.colors.primary};
    background: ${props => props.theme.colors.surface};
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.primary}40;
  }
`;

const ToggleSlider = styled(motion.div)`
  width: 20px;
  height: 20px;
  background: ${props => props.theme.colors.primary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  svg {
    width: 12px;
    height: 12px;
    color: white;
  }
`;

const ToggleLabel = styled.span`
  font-size: ${props => props.theme.typography.caption.fontSize};
  color: ${props => props.theme.colors.text.secondary};
  font-weight: 500;
`;

const ThemeToggle = ({ showLabel = true }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <ToggleContainer>
      {showLabel && (
        <ToggleLabel>
          {isDarkMode ? 'Dark' : 'Light'} Mode
        </ToggleLabel>
      )}
      <ToggleButton
        onClick={toggleTheme}
        whileTap={{ scale: 0.95 }}
        whileHover={{ scale: 1.02 }}
      >
        <ToggleSlider
          animate={{
            x: isDarkMode ? 0 : 24,
          }}
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25
          }}
        >
          <motion.div
            animate={{ rotate: isDarkMode ? 0 : 180 }}
            transition={{ duration: 0.2 }}
          >
            {isDarkMode ? <MoonIcon /> : <SunIcon />}
          </motion.div>
        </ToggleSlider>
      </ToggleButton>
    </ToggleContainer>
  );
};

export default ThemeToggle; 